module.exports = __webpack_public_path__ + "img/11.ba40a62a.png";